module.exports = __webpack_public_path__ + "img/pr-6.ce220a05.png";